import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { FormControl, FormControlLabel, RadioGroup, Radio } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1)
  },
  selectEmpty: {
    marginTop: theme.spacing(2)
  }
}));

const GeneralCondition = ({ animalinfo, generalcondition, handleGeneralCondition }) => {
  const classes = useStyles();

  const data = useStaticQuery(graphql`
    query generalConditionLabelsQuery {
      generalConditionLabels: sanityGeneralConditionLabels {
        irregularBehaviorLabel
        noReactionLabel
        noneLabel
        notWalkingLabel
      }
    }
  `);

  const generalConditionLabelsData = (data || {}).generalConditionLabels;

  return (
    <>
      <div className="formStep--wrapper">
        <h2>Wie ist der Allgemeinzustand von {animalinfo.animalname || "Das Tier"}?</h2>

        <div className="generalCondition--grid">
          <FormControl component="fieldset" className={`${classes.formControl} generalCondition`}>
            <RadioGroup
              aria-label="generalCondition"
              name="generalCondition"
              value={generalcondition}
              onChange={handleGeneralCondition}
            >
              <FormControlLabel
                className={classes.formLabel}
                value="none"
                control={<Radio />}
                label={generalConditionLabelsData.noneLabel}
              />

              <FormControlLabel
                value="noReaction"
                control={<Radio />}
                label={generalConditionLabelsData.noReactionLabel}
              />
              <FormControlLabel
                value="notWalking"
                control={<Radio />}
                label={generalConditionLabelsData.notWalkingLabel}
              />

              <FormControlLabel
                value="irregularBehavior"
                control={<Radio />}
                label={generalConditionLabelsData.irregularBehaviorLabel}
              />
            </RadioGroup>
          </FormControl>
        </div>
      </div>
    </>
  );
};

export default GeneralCondition;
